var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.164259 0.936646L5.81873 6.5547L0.164259 12.1727C0.0620427 11.9591 2.76566e-05 11.7229 2.76566e-05 11.4707V1.63869C2.76566e-05 1.38644 0.0620427 1.15029 0.164259 0.936646Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63864 0H17.0057C17.258 0 17.4941 0.0620146 17.7078 0.164231L10.4808 7.35482C9.84175 7.99383 8.80261 7.99383 8.1636 7.35482L0.936598 0.164231C1.15024 0.0620146 1.38639 0 1.63864 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4802 0.936646C18.5824 1.15029 18.6444 1.38644 18.6444 1.63869V11.4707C18.6444 11.723 18.5824 11.9591 18.4802 12.1727L12.8257 6.5547L18.4802 0.936646Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59106 7.32703L7.39121 8.12717C8.45594 9.19191 10.1885 9.19191 11.2532 8.12717L12.0533 7.32703L17.7078 12.9451C17.4941 13.0473 17.258 13.1093 17.0057 13.1093H1.63864C1.38639 13.1093 1.15024 13.0473 0.936598 12.9451L6.59106 7.32703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bb6731643af12472e7090c5358049f98.svg";
export { ForwardRef as ReactComponent };